import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_CLIENT_SCHEMA_LITERAL = {
    title: 'Schéma Clients',
    description: 'Décrit un client',
    version: 0,
    keyCompression: false,
    primaryKey: 'CT_NUM',
    type: 'object',
    properties: {
        CT_NUM: { type: 'string', default: '', maxLength: 20 },
        CT_INTITULE: { type: 'string', default: '', maxLength: 70 },
        CT_TYPE: { type: 'number' },
        CT_PROSPECT: { type: 'number' },
        N_CATTARIF: { type: 'number' },
        N_CATTARIFLIB: { type: 'string', default: '' },
        N_CATCOMPTA: { type: 'number' },
        N_CATCOMPTALIB: { type: 'string', default: '' },
        N_DEVISE: { type: 'number' },
        N_DEVISELIB: { type: 'string', default: '' },
        N_DEVISE_COURS: { type: 'number' },
        N_DEVISE_FORMAT: { type: 'string', default: '' },
        CT_CONTACT : { type : 'string' },
        CT_COMMENTAIRE : { type : 'string' },
        CT_IDENTIFIANT: { type: 'string', default: '' },
        CT_APE: { type: 'string', default: '' },
        CT_SIRET: { type: 'string', default: '' },
        CT_TELEPHONE: { type: 'string', default: '' },
        CT_TELECOPIE : { type : 'string' },
        CT_EMAIL: { type: 'string', default: '' },
        CT_SITE : { type : 'string' },
        CT_LINKEDIN : { type : 'string' },
        CT_FACEBOOK : { type : 'string' },
        CT_ADRESSE: { type: 'string', default: '' },
        CT_COMPLEMENT: { type: 'string', default: '' },
        CT_VILLE: { type: 'string', default: '' },
        CT_PAYS: { type: 'string', default: '' },
        CT_CODEPOSTAL: { type: 'string', default: '' },
        CT_CODEREGION: { type: 'string', default: '' }, 
        CT_TAUX01 : { type: 'number' },
        CO_NO : { type: ['number', 'null'] },
        CO_NOLIB : { type: ['string', 'null'] },
        CONTACT_ITEMS_JSON : { type : 'string' },
        ADRESSE_ITEMS_JSON : { type : 'string' },
        EXTRA: { type: ['string', 'null'] }
    },
    required: [ 'CT_NUM', 'CT_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_CLIENT_SCHEMA_LITERAL);
export type RxFClientDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_CLIENT_SCHEMA: RxJsonSchema<RxFClientDocumentType> = F_CLIENT_SCHEMA_LITERAL;
